import { request } from 'api/request';

import { cleanSearchParams } from 'utils/common';

import type { UserType } from 'pages/permissions/types';

import type { Value } from 'components/Toolbar/types';

import type { BaseHookProps, ERROR_DATA } from '../type';
import { useQuery } from '@tanstack/react-query';

interface GetUsersListParams extends BaseHookProps {
    searchParams?: {
        name?: string;
        project_id?: Value;
    };
}

const apiRequest = async (searchParams: GetUsersListParams['searchParams']) => {
    return await request<UserType[]>('admin/users', { params: cleanSearchParams(searchParams ?? {}) });
};

export const useGetUsersList = ({ searchParams }: GetUsersListParams) => {
    return useQuery<UserType[], ERROR_DATA<unknown>>({
        queryKey: ['users', searchParams],
        queryFn: () => apiRequest(searchParams),
        refetchOnWindowFocus: false,
    });
};
